(function () {
  function getVariantData(productId) {
    const el = document.getElementById(`VariantData-${productId}`);
    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getSelectedOptionValueByName(container, optionName) {
    const radio = container.querySelector(
      `input[name="${optionName}"]:checked`
    );
    if (radio) return radio.value;

    const select = container.querySelector(
      `select[name="${optionName}"]`
    );
    if (select) return select.value;

    return null;
  }

  function updateAvailability(container, variants) {
    const selectedColor = getSelectedOptionValueByName(container, "Farbe");
    if (!selectedColor) return;

    // option2 = Farbe, option1 = Grösse
    const availableSizes = new Set(
      variants
        .filter(v => v.available && v.option2 === selectedColor)
        .map(v => v.option1)
        .filter(Boolean)
    );

    const allSizes = new Set(
      variants.map(v => v.option1).filter(Boolean)
    );

    // 👉 ALLE soldout-Markierungen an GRÖSSEN zuerst entfernen
    container
      .querySelectorAll(
        'label.product-form__input__radio-label:not(.product-form__input__radio-label--color)'
      )
      .forEach(label => {
        label.classList.remove("soldout");
      });

    // 👉 soldout NUR für nicht verfügbare GRÖSSEN setzen
    allSizes.forEach(size => {
      const input = container.querySelector(
        `input[name="Grösse"][value="${CSS.escape(size)}"]`
      );
      if (!input) return;

      const label = container.querySelector(`label[for="${input.id}"]`);
      if (!label) return;

      if (!availableSizes.has(size)) {
        label.classList.add("soldout");
      }
    });
  }

  function init() {
    document.querySelectorAll("[data-product-id]").forEach(section => {
      const productId = section.getAttribute("data-product-id");
      const variants = getVariantData(productId);
      if (!variants) return;

      const handler = () => updateAvailability(section, variants);

      handler();
      section.addEventListener("change", handler);
    });
  }

  document.addEventListener("DOMContentLoaded", init);
})();
